import { Field, Form, Formik } from "formik";
import { DateTime } from "luxon";
import React, { useEffect } from "react";
import {
  Accordion, Button, Card, Col, Container, Modal, Row, Toast
} from "react-bootstrap";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FormattedMessage, injectIntl } from "react-intl";
import { queryCache, useMutation, useQuery } from 'react-query';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Alert from "react-s-alert";
import _ from "underscore";
import urlSlug from "url-slug";
import * as Yup from "yup";
import ArchiveHeader from "../../../components/ArchiveHeader";
import PageLoading from '../../../components/Loading';
import ProfileModal from '../../../components/ProfileModal';
import { LinkIcon, PreIcon, VidIcon } from '../../../components/svgs';
import {
  DateInputFloating, ImageUploadCustom, Input,
  InputFloatingLabel, ReactSelect, ReactSwitch,
  // Select,
  RichText
} from "../../../formik";
import { scheduleItemsFetch } from "../../../redux/actions/schedule";
import { purchaseCredits } from "../../../redux/actions/user";
import ParticipantsListModal from "../presentations/participants-list-modal";
import { getEvent, postEvent, putEvent } from "./xhr";



const EventForm = ({
  intl,
  match,
  history,
  associations,
  scheduleItemsFetch,
  purchaseCredits,
  locale,
  setLocale
}) => {

  const { isLoading, data } = useQuery(['events', match && match.params && match.params.id], getEvent, {
    enabled: match && match.params && match.params.id,
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  useEffect(() => {
    scheduleItemsFetch();
  }, [scheduleItemsFetch]);

  const editForm = match.params.id ? true : false

  const [creditsToBePurchased, setCreditsToBePurchased] = React.useState(0);
  const [showAccount, setShowAccount] = React.useState(false);
  const [showCreditPurcahseModal, setShowCreditPurcahseModal] = React.useState(false);
  const [hovered, setHovered] = React.useState(false);
  const [hoveredTwo, setHoveredTwo] = React.useState(false);
  const [copied, setCopied] = React.useState(false);
  const [copiedTwo, setCopiedTwo] = React.useState(false);
  let submitButtonText = intl.formatMessage({
    id: editForm ? "button.save" : "button.createEvent",
  });
  const [showParticipantsModal, setShowParticipantsModal] = React.useState(false);
  function handleParticipantsModal() {
    setShowParticipantsModal(!showParticipantsModal)
  }
  // const displayModeOptions = [
  //   {
  //     value: "public",
  //     label: intl.formatMessage({
  //       id: "select.displayMode.public",
  //     }),
  //   },
  //   {
  //     value: "password",
  //     label: intl.formatMessage({
  //       id: "select.displayMode.password",
  //     }),
  //   },
  //   {
  //     value: "link",
  //     label: intl.formatMessage({ id: "select.displayMode.link" }),
  //   },
  //   {
  //     value: 'login',
  //     label: intl.formatMessage({ id: 'select.login.and.password' })
  //   }
  // ];

  const closeCreditPurcahseModal = () => {
    setShowCreditPurcahseModal(!showCreditPurcahseModal);
  };

  const [postEventMutation] = useMutation(postEvent, {
    onSuccess: (createdEvent) => {
      if (queryCache.getQueryData('events')) {
        queryCache.setQueryData('events', events => events.concat([createdEvent]));
      }
      Alert.success(intl.formatMessage({ id: 'event.create-success' }));
      history.push("/");
    },
    onError: (err) => {
      if (err.response.data.message === "error.not-enough-credits") {
        setCreditsToBePurchased(err.response.data.details["credits-required"]);
        setShowCreditPurcahseModal(!showCreditPurcahseModal);
      }
      Alert.error(intl.formatMessage({ id: err.response.data.message }));
    }
  })
  const addEvent = async (values) => {
    Alert.warning(intl.formatMessage({id: "event.creating"}));
    await postEventMutation({
      event: _.pick(
        values,
        ["name",
        "slug",
        "logo",
        "start",
        "end",
        "uploadByDate",
        "venue",
        // "displayMode",
        "displayPassword",
        "ad",
        "associations",
        "forum",
        "quiz",
        // "moderator_site_password",
        "schedule_background_color",
        "schedule_text_color",
        "show_video_views",
        "allowCreateAccount",
        "autoValidateAccounts",
        "allowAnonymousAccess",
        "authorizeAssosicationLogin",
        "authorizeSpeakerLogin",
        "externalURL"]
      ),
    })
  };

  const [putEventMutation] = useMutation(putEvent, {
    onSuccess: (updatedEvent) => {
      console.log('debug: updatedEvent: ', updatedEvent);
      if (queryCache.getQueryData('events')) {
        queryCache.setQueryData('events', events => events
          .map(event => event._id === updatedEvent._id ? updatedEvent : event)
        )
      }
      queryCache.setQueryData(['events', updatedEvent._id], event => ({
        ...event,
        event: updatedEvent,
      }))
      Alert.success(intl.formatMessage({ id: 'event.update-success' }));
      history.push("/");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })


  const editEvent = async (values) => {
    Alert.warning(intl.formatMessage({id: "event.updating"}));
    await putEventMutation({
      _id: match.params.id,
      event: _.pick(
        values,
        ["name",
        "slug",
        "logo",
        "start",
        "end",
        "uploadByDate",
        "venue",
        "ad",
        // "displayMode",
        "associations",
        "forum",
        "quiz",
        // "moderator_site_password",
        "schedule_background_color",
        "schedule_text_color",
        "show_video_views",
        "displayPassword",
        "allowCreateAccount",
        "autoValidateAccounts",
        "allowAnonymousAccess",
        "authorizeAssosicationLogin",
        "authorizeSpeakerLogin",
        "externalURL"]
      ),
    })
  }

  if (editForm && isLoading) {
    return <PageLoading />
  }
  
  const slugValidation = value => {
    let errorMessage;
    if (!/^[a-zA-Z0-9-]+$/g.test(value)) {
      errorMessage = 'Special characters not allowed';
    }
    return errorMessage;
  };

  // console.log(event)
  const initialValues =
    editForm && data.event
      ? {
        name: data.event.name,
        slug: data.event.slug,
        logo: data.event.logo,
        start: DateTime.fromISO(data.event.start).toFormat("yyyy-MM-dd"),
        end: data.event.end ? DateTime.fromISO(data.event.end).toFormat("yyyy-MM-dd") : "",
        uploadByDate: data.event.uploadByDate ? DateTime.fromISO(data.event.uploadByDate).toFormat("yyyy-MM-dd") : "",
        venue: data.event.venue,
        // displayMode: data.event.displayMode,
        displayPassword: data.event.displayPassword,
        ad: data.event.ad ? data.event.ad : '',
        associations: data.event.associations ? data.event.associations : [],
        forum: data.event.forum,
        quiz: data.event.quiz,
        // moderator_site_password: data.event.moderator_site_password,
        schedule_background_color: data.event.schedule_background_color,
        schedule_text_color: data.event.schedule_text_color,
        show_video_views: data.event.show_video_views,
        // loginMode: data.event.loginMode || "global",
        allowCreateAccount: !!data.event.allowCreateAccount,
        autoValidateAccounts: !!data.event.autoValidateAccounts,
        allowAnonymousAccess: !!data.event.allowAnonymousAccess,
        authorizeAssosicationLogin: !!data.event.authorizeAssosicationLogin,
        authorizeSpeakerLogin: !!data.event.authorizeSpeakerLogin,
        externalURL: data.event.externalURL || '',
      }
      : {
        name: match.params.name ? match.params.name : '',
        slug:urlSlug(match.params.name ? match.params.name : ''),
        logo: "",
        start: "",
        end: "",
        uploadByDate: "",
        venue: "",
        // displayMode: "public",
        displayPassword: "",
        ad: "",
        associations: [],
        forum: false,
        quiz: false,
        // moderator_site_password: "",
        schedule_background_color: "",
        schedule_text_color: "",
        show_video_views: false,
        // loginMode: "global",
        allowCreateAccount: true,
        autoValidateAccounts: true,
        allowAnonymousAccess: true,
        authorizeAssosicationLogin: false,
        authorizeSpeakerLogin: false,
        externalURL: ''
      }

  const ValidationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    slug: Yup.string().required("Required"),
    start: Yup.date().required("Required"),
    end: Yup.date().required("Required"),
    uploadByDate: Yup.date().required("Required"),
    // displayMode: Yup.string().required("Required"),
  });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => editForm ? editEvent(values) : addEvent(values)}
      enableReinitialize={true}
      validationSchema={ValidationSchema}
    >
      {({ values, setFieldValue }) => {
        return (
          <React.Fragment>
            {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
            <Form className="add-event-form floating-label-form">
              <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title="add.edit.event" back backLink="/" save />
              <div className="pad-2rem">
                <Container fluid>
                  <Row>
                    <Col>
                      <Row>
                        <Col md={8} lg={9}>
                          <Field
                            className="gray-input border-bottom-input"
                            component={InputFloatingLabel}
                            type="text"
                            name="name"
                            id="name"
                            placeholder={`${intl.formatMessage({
                              id: "input.event.name",
                            })}`}
                            label={`${intl.formatMessage({
                              id: "input.event.name",
                            })}`}
                            handleBlur={() => {
                              if (values.slug) return;
                              if (values.name) {
                                setFieldValue("slug", urlSlug(values.name),false);
                              }
                            }}
                            required
                          />
                          <Field
                            className="gray-input"
                            component={InputFloatingLabel}
                            type="text"
                            name="displayPassword"
                            id="displayPassword"
                            placeholder={`${intl.formatMessage({
                              id: "block.access.presentation.with.password",
                            })}`}
                            label={`${intl.formatMessage({
                              id: "block.access.presentation.with.password",
                            })}`}
                          />
                           <Row className="m-b-20">
                            <Col>
                              <div className="show-public-views m-b-0-fg">
                                <Field
                                  component={ReactSwitch}
                                  offColor="#b1b1b1"
                                  onColor="#f9962e"
                                  name="allowCreateAccount"
                                  id="allowCreateAccount"
                                />
                                <p className="m-l-10">{intl.formatMessage({ id: 'allow.creating.account' })}</p>
                              </div>
                            </Col>
                          </Row>
                          {
                            values.allowCreateAccount &&
                            <Row className="m-b-20">
                              <Col>
                                <div className="show-public-views m-b-0-fg">
                                  <Field
                                    component={ReactSwitch}
                                    offColor="#b1b1b1"
                                    onColor="#f9962e"
                                    name="autoValidateAccounts"
                                    id="autoValidateAccounts"
                                  />
                                  <p className="m-l-10">{intl.formatMessage({ id: 'allow.validate.accounts' })}</p>
                                </div>
                              </Col>
                            </Row>
                          }
                          <Row className="m-b-20">
                            <Col>
                              <div className="show-public-views m-b-0-fg">
                                <Field
                                  component={ReactSwitch}
                                  offColor="#b1b1b1"
                                  onColor="#f9962e"
                                  name="allowAnonymousAccess"
                                  id="allowAnonymousAccess"
                                />
                                <p className="m-l-10">{intl.formatMessage({ id: 'allow.anonymous.access' })}</p>
                              </div>
                            </Col>
                          </Row>
                        
                          <Row className="m-b-20">
                            <Col>
                              <div className="show-public-views m-b-0-fg">
                                <Field
                                  component={ReactSwitch}
                                  offColor="#b1b1b1"
                                  onColor="#f9962e"
                                  name="authorizeAssosicationLogin"
                                  id="authorizeAssosicationLogin"
                                />
                                <p className="m-l-10">{intl.formatMessage({ id: 'authorize.assosication.login' })}</p>
                              </div>
                            </Col>
                          </Row>
                          <Row className="m-b-20">
                            <Col>
                              <div className="show-public-views m-b-0-fg">
                                <Field
                                  component={ReactSwitch}
                                  offColor="#b1b1b1"
                                  onColor="#f9962e"
                                  name="authorizeSpeakerLogin"
                                  id="authorizeSpeakerLogin"
                                />
                                <p className="m-l-10">{intl.formatMessage({ id: 'authorize.speaker.login' })}</p>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={7}>
                              <Field
                                className="gray-input"
                                component={InputFloatingLabel}
                                type="text"
                                name="venue"
                                id="venue"
                                placeholder={`${intl.formatMessage({
                                  id: "input.event.venue",
                                })}`}
                                label={`${intl.formatMessage({
                                  id: "input.event.venue",
                                })}`}
                              />
                            </Col>
                            <Col md={5}>
                              <Field
                                className="gray-input"
                                component={InputFloatingLabel}
                                type="text"
                                name="slug"
                                id="slug"
                                validate={slugValidation}
                                placeholder={`${intl.formatMessage({
                                  id: "input.event.slug",
                                })}`}
                                label={`${intl.formatMessage({
                                  id: "input.event.slug",
                                })}`}
                                required
                              />
                            </Col>
                          </Row>
                          <Row className="align-items-center">
                            <Col className="text-right" md={1}>
                              <img
                                width={33}
                                alt=""
                                src="/images/date-ico.png"
                                className="img-fluid"
                              />
                            </Col>
                            <Col md={3}>
                              {
                                editForm ?
                                  <Field
                                    component={DateInputFloating}
                                    name="start"
                                    id="start"
                                    placeholder={`${intl.formatMessage({
                                      id: "input.event.start",
                                    })}`}
                                    label={`${intl.formatMessage({
                                      id: "input.event.start",
                                    })}`}
                                    minDate={DateTime.local().toJSDate()}
                                    disabled={DateTime.fromFormat(values.start, "yyyy-MM-dd").toJSDate() < DateTime.local().toJSDate() ? true : false}
                                    required
                                  />
                                  :
                                  <Field
                                    component={DateInputFloating}
                                    name="start"
                                    id="start"
                                    placeholder={`${intl.formatMessage({
                                      id: "input.event.start",
                                    })}`}
                                    label={`${intl.formatMessage({
                                      id: "input.event.start",
                                    })}`}
                                    minDate={DateTime.local().toJSDate()}
                                    required
                                  />
                              }
                            </Col>
                            <Col md={3}>
                              <Field
                                component={DateInputFloating}
                                name="end"
                                id="end"
                                placeholder={`${intl.formatMessage({
                                  id: "input.event.end",
                                })}`}
                                label={`${intl.formatMessage({
                                  id: "input.event.end",
                                })}`}
                                minDate={
                                  values.start
                                    ? DateTime.fromFormat(
                                      values.start,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                    : DateTime.local().toJSDate()
                                }
                                disabled={editForm || !values.start}
                                required
                              />
                            </Col>
                            <Col></Col>
                          </Row>
                          <Row className="align-items-center">
                            <Col md={1}></Col>
                            <Col md={3}>
                              <Field
                                component={DateInputFloating}
                                name="uploadByDate"
                                id="uploadByDate"
                                placeholder={`${intl.formatMessage({
                                  id: "input.event.uploadByDate",
                                })}`}
                                label={`${intl.formatMessage({
                                  id: "input.event.uploadByDate",
                                })}`}
                                maxDate={
                                  values.end
                                    ? DateTime.fromFormat(
                                      values.end,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                    : DateTime.local().toJSDate()
                                }
                                disabled={!values.start}
                                required
                              />
                            </Col>
                            <Col md={4}>
                              <p className="form-text-light">
                                {intl.formatMessage({ id: 'deadline.text' })}
                              </p>
                            </Col>
                          </Row>

                          <Row>
                            <Col>
                              <h3 className="m-t-30 form-h3 m-b-20">Options</h3>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={4}>
                              <Card>
                                <Card.Body className="bg-white text-center pb-0">
                                  <Card.Title>
                                    <img width={56} className="m-b-10" alt="" src="/images/quiz-ico.png" />
                                    <h4>
                                      <FormattedMessage id="input.event.quiz" />
                                    </h4>
                                    <p>
                                      <FormattedMessage id="event.form.price-quiz" />
                                    </p>
                                  </Card.Title>
                                  <Card.Text>
                                    <Field
                                      component={ReactSwitch}
                                      offColor="#525561"
                                      onColor="#f9962e"
                                      name="quiz"
                                      id="quiz"
                                    // disabled={editForm}
                                    />
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </Col>
                            <Col md={4}>
                              <Card>
                                <Card.Body className="bg-white text-center pb-0">
                                  <Card.Title>
                                    <img width={49} className="m-b-10" alt="" src="/images/forum-ico.png" />
                                    <h4>
                                      <FormattedMessage id="input.event.forum" />
                                    </h4>
                                    <p>
                                      <FormattedMessage id="event.form.price-forum" />
                                    </p>
                                  </Card.Title>
                                  <Card.Text>
                                    <Field
                                      component={ReactSwitch}
                                      name="forum"
                                      offColor="#525561"
                                      onColor="#f9962e"
                                      id="forum"
                                    // disabled={editForm}
                                    />
                                  </Card.Text>
                                </Card.Body>
                              </Card>
                            </Col>
                            <Col md={4}>
                              {/*
                                (values.quiz || values.forum) && (
                                <Card className="mod-pass">
                                  <Card.Footer className="bg-white text-center pb-0">
                                    <Field
                                      component={InputFloatingLabel}
                                      name="moderator_site_password"
                                      id="moderator_site_password"
                                      type="password"
                                      // required={values.moderator_site}
                                      // disabled={!values.moderator_site}
                                      placeholder={intl.formatMessage({
                                        id:
                                          "input.event.moderator_site_password",
                                      })}
                                      label={intl.formatMessage({
                                        id:
                                          "input.event.moderator_site_password",
                                      })}
                                    />
                                    <p className="m-t-20">
                                      {intl.formatMessage({ id: 'access.moderator.site' })}
                                    </p>
                                  </Card.Footer>
                                </Card>
                              )
                              */}
                            </Col>
                          </Row>
                        </Col>
                        <Col>
                          <Card className="img-upload">
                            <Card.Body>
                              <Card.Text>
                                <Field
                                  component={ImageUploadCustom}
                                  id="logo"
                                  name="logo"
                                  // placeholder={intl.formatMessage({
                                  //   id: "input.event.logo",
                                  // })}
                                  accept="image/*"
                                  buttonEmpty="add.logo"
                                  buttonUploaded={intl.formatMessage({
                                    id: "label.logoUploaded",
                                  })}
                                  sizeWarning={intl.formatMessage({ id: "error.fileTooBig" })}
                                  maxSize={
                                    process.env.REACT_APP_IMAGE_FILE_SIZE_MAX
                                  }
                                />
                                {
                                  match.params.id && <div className="d-flex site-details align-items-center">
                                    <span className={(hovered || hoveredTwo) ? 'hover-state' : ''}><LinkIcon /></span>
                                    <div className="m-l-30">
                                      <span className="d-flex relative">
                                        <a onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${data.event.slug}`}>
                                          <span className="d-block">{intl.formatMessage({ id: 'site.moderator' })}</span>
                                        </a>
                                        <CopyToClipboard text={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${data.event.slug}`}
                                          onCopy={() => setCopied(true)}>
                                          <span className="copy-to-clip d-inline-block m-l-10"><i className="fas fa-copy"></i></span>
                                        </CopyToClipboard>
                                        <Toast className="toast-custom" onClose={() => setCopied(false)} show={copied} delay={1000} autohide>
                                          <Toast.Header>
                                            <small><b>{intl.formatMessage({ id: 'copied.text' })}</b></small>
                                          </Toast.Header>
                                        </Toast>
                                      </span>
                                      <span className="d-flex relative m-t-10">
                                        <a onMouseEnter={() => setHoveredTwo(true)} onMouseLeave={() => setHoveredTwo(false)} target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${data.event.slug}`}>
                                          <span className="d-block">{intl.formatMessage({ id: 'site.audience' })}</span>
                                        </a>
                                        <CopyToClipboard text={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${data.event.slug}`}
                                          onCopy={() => setCopiedTwo(true)}>
                                          <span className="copy-to-clip d-inline-block m-l-10"><i className="fas fa-copy"></i></span>
                                        </CopyToClipboard>
                                        <Toast className="toast-custom" onClose={() => setCopiedTwo(false)} show={copiedTwo} delay={1000} autohide>
                                          <Toast.Header>
                                            <small><b>{intl.formatMessage({ id: 'copied.text' })}</b></small>
                                          </Toast.Header>
                                        </Toast>
                                      </span>
                                    </div>
                                  </div>
                                }
                                {
                                  match.params.id && <div className="pre-vids-form">
                                    <Link to={`/manage-event/${match.params.id}`}>
                                      <Button>
                                        <PreIcon />
                                        {intl.formatMessage({ id: 'common.presentations.text' })}
                                      </Button>
                                    </Link>
                                    <a href={`${process.env.REACT_APP_AUDIENCE_SITE_ROOT}/${data.event.slug}`} target="_blank" rel="noopener noreferrer">
                                      <Button className="m-t-10">
                                        <VidIcon />
                                        {intl.formatMessage({ id: 'common.videos.text' })}
                                      </Button>
                                    </a>
                                    <Button className="participants-list-btn" onClick={() => handleParticipantsModal()}>
                                      <i className="far fa-address-book"></i>
                                      <FormattedMessage id="participants.list" />
                                    </Button>
                                  </div>
                                }
                                <div className="download-app">
                                  <a
                                    href={`${process.env.REACT_APP_WP_SITE_ROOT}/telechargement-e-slides/`}
                                    download
                                  >
                                    <img
                                      alt=""
                                      src="/images/download-app-ico.png"
                                    />
                                    {intl.formatMessage({ id: 'download.app.text' })}
                                  </a>
                                </div>
                              </Card.Text>
                            </Card.Body>
                          </Card>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="form-videos m-t-50">
                           
                            <Row>
                              {/* <Col md={3}>
                                {
                                  values.displayMode === "login" && <RadioButtonGroup
                                    id="loginMode"
                                  >
                                    <Row>
                                      <Col>
                                        <Field
                                          component={RadioButton}
                                          name="loginMode"
                                          id="global"
                                          label={intl.formatMessage({ id: 'authenticationMode.global' })}
                                          value="global"
                                        />
                                        <Field
                                          component={RadioButton}
                                          name="loginMode"
                                          id="whitelist"
                                          label={intl.formatMessage({ id: 'authenticationMode.whitelist' })}
                                          value="whitelist"
                                        />
                                      </Col>
                                    </Row>
                                  </RadioButtonGroup>
                                }
                              </Col> */}
                              {/* <Col md>
                                <div className="show-public-views m-b-0-fg">
                                  <p>{intl.formatMessage({ id: 'show.public.video.views' })}</p>
                                  <Field
                                    component={ReactSwitch}
                                    offColor="#b1b1b1"
                                    onColor="#f9962e"
                                    name="show_video_views"
                                    id="show_video_views"
                                  />
                                </div>
                              </Col> */}
                            </Row>
                            <Field
                              component={RichText}
                              // as="textarea"
                              // rows="8"
                              name="ad"
                              id="ad"
                              placeholder={intl.formatMessage({
                                id: "input.event.web_ad",
                              })}
                              label={intl.formatMessage({
                                id: "input.event.web_ad",
                              })}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Container>
              </div>
              {/* Advanced Settings */}
              <div className="advanced-settings m-t-40">
                <Container fluid>
                  <Row>
                    <Col>
                      <Accordion>
                        <Accordion.Toggle as={Button} eventKey="0">
                          <FormattedMessage id="advanced.settings" />
                          <img src="/icons/chev_down.png" alt="down" />
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                          <div className="pad-2rem-b-20 settings-form">
                            <Row>
                              <Col md={6}>
                                <Field
                                  type="color"
                                  component={Input}
                                  name="schedule_background_color"
                                  id="schedule_background_color"
                                  placeholder={intl.formatMessage({ id: "input.event.schedule_background_color" })}
                                  label={intl.formatMessage({ id: "input.event.schedule_background_color" })}
                                />
                              </Col>
                              <Col md={6}>
                                <Field
                                  type="color"
                                  component={Input}
                                  name="schedule_text_color"
                                  id="schedule_text_color"
                                  placeholder={intl.formatMessage({ id: "input.event.schedule_text_color" })}
                                  label={intl.formatMessage({ id: "input.event.schedule_text_color" })}
                                />
                              </Col>
                            </Row>
                            <Field
                            className="gray-input"
                            component={InputFloatingLabel}
                            type="url"
                            name="externalURL"
                            id="externalURL"
                            placeholder={`${intl.formatMessage({
                              id: "connection.externalURL",
                            })}`}
                            label={`${intl.formatMessage({
                              id: "connection.externalURL",
                            })}`}
                          />

<h3>{intl.formatMessage({ id: 'common.videos.text' })}</h3>
                            {/* <Row></Row> */}
                            <div className="align-items-center ">
                              {/* <Col md>
                                <div className="web-bg" style={{ backgroundImage: `url('/images/web-${values.displayMode}.svg')` }}>
                                  <Field
                                    component={ReactSelect}
                                    name="displayMode"
                                    id="displayMode"
                                    handleChange={(newValue) => {
                                      if (newValue !== "password") {
                                        setFieldValue("displayPassword", "");
                                      }
                                    }}
                                    options={displayModeOptions.map(o => ({
                                      value: o.value,
                                      label: o.label
                                    }))}
                                    required
                                  />
                                </div>
                              </Col> */}
                              {/* <Col>
                                <Field
                                  component={InputFloatingLabel}
                                  type="text"
                                  name="displayPassword"
                                  id="displayPassword"
                                  placeholder={`${intl.formatMessage({
                                    id: "input.event.displayPassword",
                                  })}`}
                                  label={`${intl.formatMessage({
                                    id: "input.event.displayPassword",
                                  })}`}
                                  required={values.displayMode === "password"}
                                  disabled={values.displayMode !== "password"}
                                />
                              </Col> */}
                              <div  md={3}>
                                <p className=" m-b-0">
                                {/* text-right */}
                                  Associations autorisées à gérer leur présentations
                                </p>
                              </div>
                              <div className="">
                                <Field
                                  component={ReactSelect}
                                  name="associations"
                                  id="associations"
                                  options={associations.map((a) => {
                                    return {
                                      value: a._id,
                                      label: a.name,
                                    };
                                  })}
                                  isMulti
                                />
                              </div>
                            </div>
                            <Row>
                              <Col md className="m-b-20">
                                <div className="show-public-views m-b-0-fg">
                                  <Field
                                    component={ReactSwitch}
                                    offColor="#b1b1b1"
                                    onColor="#f9962e"
                                    name="show_video_views"
                                    id="show_video_views"
                                  />
                                  <p>{intl.formatMessage({ id: 'show.public.video.views' })}</p>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Accordion.Collapse>
                      </Accordion>
                    </Col>
                  </Row>
                </Container>
              </div>
              <div className="pad-2rem">
                <Container fluid>
                  <Row>
                    <Col>
                      <div className="form-buttons m-t-30 m-b-30 text-center">
                        <Link to="/">
                          <Button className="btn-black">
                            {intl.formatMessage({
                              id: "button.back",
                            })}
                          </Button>
                        </Link>
                        <Button className="btn-custom m-l-20" type="submit">
                          {submitButtonText}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </Form>
            <div className="static-modal">
              <Modal
                show={showCreditPurcahseModal !== false}
                onHide={closeCreditPurcahseModal}
                size="small"
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <FormattedMessage id="heading.purchase-credits" />
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <center>
                    <Button
                      variant="primary"
                      onClick={() => purchaseCredits(creditsToBePurchased)}
                    >
                      Purchase {creditsToBePurchased} credits for{" "}
                      {creditsToBePurchased * process.env.REACT_APP_COST_PER_CREDIT}{" "}
                            Euros
                          </Button>
                    <br />
                    <br />
                    <Button onClick={() => setShowAccount(!showAccount)} variant="default">Link/Update Credit Card</Button>
                    <ProfileModal show={showAccount} setShow={(bool) => setShowAccount(bool)} />
                  </center>
                </Modal.Body>
              </Modal>
              {
                data && data.event &&
                <ParticipantsListModal
                  intl={intl}
                  showParticipantsModal={showParticipantsModal}
                  handleParticipantsModal={handleParticipantsModal}
                  event={data.event}
                />
              }
            </div>
          </React.Fragment>
        );
      }}
    </Formik>

  );
};


const mapStateToProps = (state) => ({
  purchasing: state.user.purchasing,
  associations: state.schedule.associations,
});

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    purchaseCredits: (credits) => dispatch(purchaseCredits(credits)),
    scheduleItemsFetch: () => dispatch(scheduleItemsFetch()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(EventForm));
